// @flow

import { LoadScript } from '@react-google-maps/api';

export default LoadScript;
